import { useParams } from 'react-router-dom';

import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

export interface CustomField {
  id: string;
  name: string;
  deleted_at: string | null;
  custom_fields_values: Array<{
    id: string;
    value: string;
  }>;
}

export const useCustomFieldsQuery = (
  isEnabled = true,
): QueryState<CustomField[]> => {
  const { company: companyId } = useParams();

  return useQuery<CustomField[], CustomField[]>({
    key: ['getCustomFields', companyId],
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/custom-fields',
    },
    isEnabled,
    reshapeData(customFields) {
      return customFields;
    },
  });
};
